<script>
import Form from '@classes/Form'
import store from '@state/store'
import { authComputed, authMethods, optionsComputed } from '@state/helpers'
import { travelHistoryService } from '@services/TravelHistoryService'
import { healthRecordService } from '@services/HealthRecordService'
import { medicalDateFormatter, isBeforeDate } from '@utils/medical-date'
import MedicalDatePickerDialog from '@components/dialogs/medical-date-picker-dialog.vue'
import hrMixin from '@src/mixins/hr-mixin.vue'

export default {
  page: {
    title: 'Travel History Editor',
    meta: [{ name: 'description', content: 'The Travel History Editor page.' }],
  },
  components: {
    MedicalDatePickerDialog,
  },
  mixins: [hrMixin],
  props: {
    formDialog: {
      type: Boolean,
      default: false,
    },
    formChanged: {
      type: Boolean,
      default: false,
    },
    formSaved: {
      type: Boolean,
      default: false,
    },
    formSavedAnother: {
      type: Boolean,
      default: false,
    },
    attachmentDeleted: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    resource: {
      type: String,
      default: 'travelhistory',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      travelHistoryForm: new Form({
        country: '',
        start: null,
        start_date_part: '',
        end: null,
        end_date_part: '',
        note: '',
        private: false,
      }),
      medicalDateStartPickerDialog: false,
      medicalDateEndPickerDialog: false,
      travelHistoryError: null,
      attachments: [],
      originalAttachments: [],
      showHRActions: true,
    }
  },
  computed: {
    ...authComputed,
    ...optionsComputed,
    countries() {
      return this.getTravelHistoryOptions?.country
        ? this.getTravelHistoryOptions.country
        : []
    },
    canSaveTravelHistory() {
      if (
        (this.travelHistoryForm.start ||
          this.travelHistoryForm.start_date_part === 'past') &&
        this.travelHistoryForm.country &&
        this.travelHistoryError === null &&
        this.dateError === null
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    travelHistoryForm: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit('update:formChanged', true)
        }
      },
      deep: true,
    },
  },
  async mounted() {
    try {
      if (!this.getTravelHistoryOptions) {
        const travelHistoryOptions = (await travelHistoryService.options()).data
        if (travelHistoryOptions) {
          store.dispatch(
            'options/setTravelHistoryOptions',
            travelHistoryOptions
          )
        }
      }

      if (this.edit) {
        if (this.item.patient_id !== null) {
          this.showHRActions = false
        }

        this.itemToForm(this.resource, this.item)
      }
    } catch (error) {
      console.warn(error)
    }
  },
  methods: {
    ...authMethods,
    clearForm() {
      this.travelHistoryForm.reset()
      this.message = false
      this.attachments = []
      this.isAnother = false
      this.isContinue = false
      this.travelHistoryError = null
      this.dateError = null
    },
    setMedicalDate(medicalDate, past) {
      const field = this.medicalDatePickerName
      const fieldPart = this.medicalDatePickerName + '_date_part'

      const medicalDateObject = medicalDateFormatter(medicalDate)

      this.travelHistoryForm[field] = medicalDateObject.date
      this.travelHistoryForm[fieldPart] = this.determinePast(
        past,
        medicalDateObject
      )
      this.medicalDateStartPickerDialog = false
      this.medicalDateEndPickerDialog = false
    },
    async getTravelHistoryResponse() {
      if (this.edit) {
        return (
          await healthRecordService.update(
            this.item.hr_id,
            this.travelHistoryForm.removeEmptyStringFromData()
          )
        ).data
      } else {
        return (
          await travelHistoryService.create(
            this.travelHistoryForm.removeEmptyFromData()
          )
        ).data
      }
    },
    async deleteAttachment(id) {
      try {
        const response = await travelHistoryService.attachmentDelete(id)
        if (response) {
          this.originalAttachments = this.originalAttachments.filter(function(
            obj
          ) {
            return obj.id !== id
          })
          this.$emit('update:attachmentDeleted', true)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    setErrors(error) {
      this.travelHistoryForm.onFail(error.response.data)
      if (this.hasResponse) {
        this.message = true
        if (this.formDialog) {
          this.$emit('update:formSaved', true)
        }
      }
      this.travelHistoryError = error
    },
    async tryToSave(action) {
      this.resetFlagsAndErrors('travelHistoryError', action)
      try {
        if (
          this.travelHistoryForm.start &&
          isBeforeDate(
            this.travelHistoryForm.start,
            new Date().toISOString().split('T')[0]
          )
        ) {
          this.dateError = this.$t('start-after-today')
          this.scrollToErrors()
          return
        }
        if (
          this.travelHistoryForm.start &&
          this.travelHistoryForm.end &&
          isBeforeDate(this.travelHistoryForm.start, this.travelHistoryForm.end)
        ) {
          this.dateError = this.$t('end-before-start')
          this.scrollToErrors()
          return
        }
        const response = await this.getTravelHistoryResponse()

        if (response) {
          this.hasResponse = true
          let responseAttachments

          if (this.attachments.length > 0) {
            responseAttachments = (
              await travelHistoryService.attachments(
                this.attachments,
                response.hr_id,
                'travelhistory'
              )
            ).data

            console.warn(responseAttachments)
          }

          await this.fetchWizardData()

          this.message = true
          if (
            action === 'continue' &&
            store.state.calender.addNewRecord === 'true'
          ) {
            this.$emit('update:formSaved', true)
            this.$emit('close-dialog')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'continue') {
            this.$emit('update:formSaved', true)
            this.edit ? this.$emit('close-dialog') : this.$emit('back')
            if (document.getElementById('getAllData'))
              document.getElementById('getAllData').click()
          }
          if (action === 'another') {
            this.$emit('update:formSavedAnother', true)
            this.clearForm()
            this.$emit('add-another')
            if (document.getElementById('updateGetAllData'))
              document.getElementById('updateGetAllData').click()
          }
        }
      } catch (error) {
        console.warn(error)
        this.setErrors(error)
        this.isAnother = false
        this.isContinue = false
        this.scrollToErrors()
      } finally {
        this.tryingToSave = false
      }
    },
    itemToForm(res, item) {
      if (item.record.start) {
        this.travelHistoryForm.start = item.record.start
      }
      this.travelHistoryForm.start_date_part = item.record.start_date_part
      if (item.record.end) {
        this.travelHistoryForm.end = item.record.end
      }
      this.travelHistoryForm.end_date_part = item.record.end_date_part
      this.travelHistoryForm.country = item.record.country?.key
      this.travelHistoryForm.note = item.note
      this.travelHistoryForm.private = item.private
      this.originalAttachments = item.attachments.map((element) => {
        return { ...element }
      })
    },
  },
}
</script>

<template>
  <v-container @dragover.prevent @drop="onDrop">
    <v-row
      no-gutters
      :class="$style.hrHeader"
      class="primary--text mt-1"
      justify="center"
    >
      <div class="mr-4">
        <v-img
          :src="
            require('@assets/images/safehaven/health-record-icons/travel.svg')
          "
          height="30"
          width="30"
          contain
        ></v-img>
      </div>
      {{ $t('health-record.travel-history.form_title') }}
    </v-row>
    <v-row
      :class="$style.hrQuestionFull"
      class="mt-7 offblack--text"
      no-gutters
      justify="center"
    >
      Where did you travel to?
    </v-row>
    <v-row class="mt-10" no-gutters justify="center">
      <v-autocomplete
        v-model="travelHistoryForm.country"
        :disabled="show"
        class="travelHistoryCountry"
        attach=".travelHistoryCountry"
        :items="countries"
        item-text="value"
        item-value="key"
        placeholder="Select country"
        rounded
        filled
        background-color="input"
        clearable
        :class="$style.hrAutoComplete"
        :error-messages="
          travelHistoryForm.errors.has('country')
            ? 'Country: ' + travelHistoryForm.errors.get('country')
            : ''
        "
        @change="
          clearFormFromErrors(
            'country',
            'travelHistoryForm',
            // eslint-disable-next-line vue/comma-dangle
            'travelHistoryError'
          )
        "
      ></v-autocomplete>
    </v-row>

    <v-row class="mt-10" no-gutters justify="center">
      <div :class="$style.hrQuestionFull" class="offblack--text"
        >When was the trip?
      </div>
    </v-row>
    <v-row v-if="dateError" class="ml-1">
      <v-col cols="12" md="12">
        <p class="error--text">{{ dateError }}</p>
      </v-col>
    </v-row>
    <v-row class="mt-10" no-gutters justify="center">
      <v-col cols="12" md="6">
        <div
          :class="mobile ? $style.medicalDateDivMobile : $style.medicalDateDiv"
        >
          <MedicalDatePickerDialog
            :key="'travelHistoryDate-1'"
            :disabled="show"
            :dialog.sync="medicalDateStartPickerDialog"
            :title="'health-record.travel-history.start-date'"
            :field="travelHistoryForm.start"
            :part="travelHistoryForm.start_date_part"
            filled
            class="mx-auto"
            background-color="input"
            :error-messages="
              travelHistoryForm.errors.has('start')
                ? 'Start Date: ' + travelHistoryForm.errors.get('start')
                : ''
            "
            @input="
              clearErrors(
                'start',
                'travelHistoryForm',
                // eslint-disable-next-line vue/comma-dangle
                'conditionError'
              )
            "
            @setMedicalDate="setMedicalDate"
            @showMedicalDate="showMedicalDate('start')"
          />
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div
          :class="mobile ? $style.medicalDateDivMobile : $style.medicalDateDiv"
        >
          <MedicalDatePickerDialog
            :key="'travelHistoryDate-2'"
            :disabled="show"
            :dialog.sync="medicalDateEndPickerDialog"
            :title="'health-record.travel-history.end-date'"
            :field="travelHistoryForm.end"
            :part="travelHistoryForm.end_date_part"
            filled
            background-color="input"
            @setMedicalDate="setMedicalDate"
            @showMedicalDate="showMedicalDate('end')"
            @input="dateError = null"
          />
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-7">
      <div :class="$style.hrQuestionFull" class="offblack--text"
        >Any additional files or notes you'd like to include?
      </div>
    </v-row>
    <v-row class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <SpeechToText
          :key="'travel-history-2'"
          :disabled="show"
          :value.sync="travelHistoryForm.note"
          auto-grow
          rounded
          :class="$style.hrSpeechToText"
          :placeholder="$t('health-record.travel-history.note')"
        ></SpeechToText>
      </div>
    </v-row>
    <v-row class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <FileUpload
          :key="'travel-history-3'"
          :disabled="show"
          icon
          :height="200"
          :multiple="true"
          :files.sync="attachments"
          :non-draggable="true"
        ></FileUpload>
      </div>
    </v-row>

    <v-row v-if="edit" class="mt-10">
      <div class="mx-auto" :class="$style.hrInputDiv">
        <AttachmentList
          :disabled="show"
          :attachments="originalAttachments"
          @delete-attachment="deleteAttachment"
        ></AttachmentList>
      </div>
    </v-row>

    <ForMyEyesOnly v-if="!show" :value.sync="travelHistoryForm.private" />
    <div v-if="showHRActions">
      <HrActions
        :can-save="canSaveTravelHistory"
        :is-another="isAnother"
        :is-continue="isContinue"
        :trying-to-save="tryingToSave"
        :trying-to-delete="tryingToDelete"
        :edit="edit"
        @go-back="goBack"
        @try-to-save="tryToSave"
        @try-to-delete="prepareDeletion"
      />
    </div>
    <v-row v-if="travelHistoryError" class="ml-1">
      <v-col cols="12" md="12">
        <p class="error--text">{{
          $t('health-record.travel-history.error')
        }}</p>
        <div v-if="travelHistoryForm.errors.has('non_field_errors')">
          <div
            v-for="(error, index) in travelHistoryForm.errors.getNonField(
              // eslint-disable-next-line vue/comma-dangle
              'non_field_errors'
            )"
            :key="'error-non-field' + index"
          >
            <p class="error--text">{{ error }}</p>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="message" class="ml-1">
      <p class="success--text">{{
        $t('health-record.travel-history.message')
      }}</p>
    </v-row>
    <BaseConfirmDialog
      v-if="confirmDialog"
      :dialog="confirmDialog"
      :message="computedMessage"
      title="Delete Item"
      @cancel="cancel"
      @confirm="deleteItem"
    />
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.hrHeader {
  // styleName: Desktop/Display X-Small Bold;
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestion {
  // styleName: Desktop/Display X-Small;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrQuestionFull {
  // styleName: Desktop/Display X-Small;
  width: 100%;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrRadio {
  // styleName: Mobile / Display Small;
  font-family: $system-default-font-family;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrComboBoxContainer {
  width: 394px;
}

.hrComboBox {
  background: $color-theme-light-input;
  border-radius: 15px !important;
}
.hrTextField {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrTextFieldCol {
  max-width: 200px !important;
  background: $color-theme-light-input;
  border-radius: 15px !important;
}
.hrAutoComplete {
  max-width: 394px !important;
  border-radius: 15px !important;
}
.hrAutoCompleteCol {
  max-width: 200px !important;
  background: $color-theme-light-input;
  border-radius: 15px !important;
}
.hrSelect {
  max-width: 394px !important;
  background: $color-theme-light-input;
  border-radius: 15px !important;
}
.hrInputDiv {
  width: 394px;
  border-radius: 15px !important;
}
.hrSpeechToText {
  max-width: 394px !important;
  background: $color-theme-light-input;
}
.cardsContainer {
  padding-right: 120px !important;
  padding-left: 120px !important;
}
.hrCard {
  border-radius: 16px !important;
}
.activeCard {
  border: 1px solid $color-theme-light-secondary !important;
}
.hrButton {
  border-radius: 8px !important;
}
.hrTextFieldSmall {
  max-width: 90px !important;
  font-size: 25px !important;
  border-radius: 15px !important;
}
.hrTextFieldSmall input {
  text-align: center !important;
}
.medicalDateDiv {
  width: 394px;
  margin-right: auto;
  margin-left: auto;
}
.medicalDateDivMobile {
  width: 60%;
  margin-right: auto;
  margin-left: auto;
}
</style>
